import React from "react";
import {
  Card,
  CardBody,
  Badge,
  Button
} from "reactstrap";
import { FiEdit2 } from "react-icons/fi";
import { IoTicketSharp } from "react-icons/io5";
import './Supporttickets.css';

function Previous_support_card({ ticket,handleEditClick }) {
  const borderClr = "#E5E7EB";
  const labelClr = "#6B7280";
  const valueClr = "#111827";
  const headlineClr = "#555555";

  return (
    <Card style={{ border: `1px solid ${borderClr}`, borderRadius: "16px" }}>
      <CardBody>
        {/* ───── Header ───── */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
          <div
            style={{
              height: 32,
              width: 32,
              borderRadius: "50%",
              backgroundColor: "#E5EEF8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: 12,
            }}
          >
            <IoTicketSharp size={18} color="#1D67AA" />
          </div>

          <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <h5 style={{ fontSize: 18, fontWeight: 600, color: headlineClr, margin: 0 }}>
              Ticket# {ticket?.ticket_id}
            </h5>
            <Badge
           
              color="primary"
              style={{
                backgroundColor: "#E5EEF8",
                color: "#fff",
                fontWeight: 600,
                fontSize: 12,
                marginLeft: 8,
                textTransform: 'capitalize',
                marginLeft:'20px'
              }}
            >
              {ticket?.status}
            </Badge>
          </div>

          <Button color="none" style={{ padding: 0, fontSize: 14, fontWeight: 600 }} onClick={()=>handleEditClick(ticket)}>
            Edit&nbsp;<FiEdit2 size={14} />
          </Button>
        </div>

        <hr style={{ border: "none", borderTop: "1px solid #BEBEBE" }} />

        {/* ───── Details ───── */}
        <section>
          <h6 style={{ fontWeight: 700, marginBottom: 12, color: "#555555" }}>Details:</h6>

          {/* Generated by */}
          <div style={{ display: "flex", marginBottom: 8 }}>
            <span style={{ width: 100, color: labelClr }}>Generated by:</span>
            <span style={{ color: valueClr, fontWeight: "400" }}>{ticket?.client_name || "N/A"}</span>
          </div>

          {/* Issue Date */}
          <div style={{ display: "flex", marginBottom: 8 }}>
            <span style={{ width: 100, color: labelClr }}>Issue Date:</span>
            <span style={{ color: valueClr, fontWeight: "400" }}>{ticket?.created_at}</span>
          </div>
        </section>

        <hr style={{ borderTop: "2px dashed #BEBEBE" }} />

        {/* ───── Priority ───── */}
        <section>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ width: 100, color: labelClr }}>Priority:</span>
            <span style={{ color: valueClr, display: "flex", alignItems: "center", textTransform: 'capitalize' }}>
              {ticket?.priority}
              <span
                style={{
                  width: 24,
                  height: 4,
                  backgroundColor: ticket?.priority === "high" ? "#DC2626" : "#FACC15",
                  borderRadius: 2,
                  display: "inline-block",
                  marginLeft: 6,
                }}
              />
            </span>
          </div>
        </section>

        <hr style={{ borderTop: "2px dashed #BEBEBE" }} />

        {/* ───── Query ───── */}
        <section style={{ paddingTop: "1.5rem" }}>
          <h6 style={{ fontWeight: 700, marginBottom: 8, color: "#555555" }}>Query:</h6>
          <p style={{ marginBottom: 0, color: valueClr, fontWeight: "400" }}>
            {ticket?.query}
          </p>
        </section>
      </CardBody>
    </Card>
  );
}

export default Previous_support_card;
